import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=49892944&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"
import style0 from "./Thread.vue?vue&type=style&index=0&id=49892944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49892944",
  null
  
)

export default component.exports